import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo">
          <h2>Stock Analysis Portal</h2>
        </div>
        <div className="nav-links">
          <Link 
            to="/upload" 
            className={`nav-link ${location.pathname === '/upload' ? 'active' : ''}`}
          >
            <i className="icon-upload"></i>
            Upload Files
          </Link>
          <Link 
            to="/dashboard" 
            className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
          >
            <i className="icon-chart"></i>
            Analytics Dashboard
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;